import { ConfigProvider } from 'antd';
import en_GB from 'antd/lib/locale/en_GB';
import i18n from 'i18next';
import moment from 'moment';
import 'moment/locale/pl';
import { useEffect, ReactNode } from 'react';
import { initReactI18next } from 'react-i18next';

import useLocale from 'translations/hooks/useLocale';

import translationResources from '../translations.resources.json';

const antLocale = {
  en_GB,
};

type Props = {
  children: ReactNode;
};

i18n.use(initReactI18next).init({
  resources: translationResources,
});

const TranslationProvider = ({ children }: Props) => {
  const { locale, language } = useLocale();

  useEffect(() => {
    // Set defaults on mount
    i18n.changeLanguage(language);
    moment.locale(language);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <ConfigProvider locale={antLocale[locale]}>{children}</ConfigProvider>;
};

export default TranslationProvider;
